import { render, staticRenderFns } from "./CustomerCustomerMessageTable.vue?vue&type=template&id=43437096&scoped=true"
import script from "./CustomerCustomerMessageTable.vue?vue&type=script&lang=js"
export * from "./CustomerCustomerMessageTable.vue?vue&type=script&lang=js"
import style0 from "./CustomerCustomerMessageTable.vue?vue&type=style&index=0&id=43437096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43437096",
  null
  
)

export default component.exports